import * as types from './constants';
import { getListAfterFilter, getSelectedList, sortByRate } from '../helper';

export const importInitState = {
  init: false,
  isLoading: false,
  isLoadingProvider: false,
  isLoadingRate: false,
  success: false,
  sortRate: 'all',
  error: null,
  errorProvider: null,
  scrollToCategoryId: null,
  scrollToServiceId: null,
  hideAdded: false,
  providerId: null,
  list: null, // Список после поиска и фильтров
  listDefault: null, // Список без изменений
  listSelected: null, // Список на импорт
  checked: [],
  options: null,
  support_copy_descriptions: false,
  search: '',
  step: 1,
};

export const importReducer = (state, action) => {
  switch (action.type) {
  case types.IMPORT_INIT:
    return {
      ...state,
      init: true,
    };
  case types.IMPORT_LOADING:
    return {
      ...state,
      isLoading: action.value,
    };
  case types.IMPORT_CHANGE_PROVIDER_ID:
    return {
      ...state,
      error: null,
      errorProvider: null,
      isLoadingProvider: true,
      providerId: action.value,
      list: null,
      listDefault: null,
      listSelected: null,
      checked: [],
      options: null,
      support_copy_descriptions: false,
    };
  case types.IMPORT_CHANGE_PROVIDER_FORM_ERROR:
    return {
      ...state,
      isLoadingProvider: false,
      errorProvider: action.error,
    };
  case types.IMPORT_CHANGE_PROVIDER_FORM_SUCCESS:
    const listWithCollapse = action.list.map((item) => ({ ...item, collapsed: true }));
    return {
      ...state,
      isLoadingProvider: false,
      list: getListAfterFilter(listWithCollapse, state.checked, state.search, state.hideAdded),
      listDefault: listWithCollapse,
      options: {
        ...action.options,
        auto_rate_fixed: null,
        auto_rate_percent: null,
        support_copy_descriptions: true,
      },
      support_copy_descriptions: action.options.support_copy_descriptions,
    };
  case types.IMPORT_TOGGLE_EDIT_CATEGORY:
    return {
      ...state,
      scrollToCategoryId: null,
      list: state.list.map((category) => {
        if (category.provider_category_id === action.id) {
          return { ...category, isEdit: action.value };
        }
        return category;
      }),
      listDefault: state.listDefault.map((category) => {
        if (category.provider_category_id === action.id) {
          return { ...category, isEdit: action.value };
        }
        return category;
      }),
    };
  case types.IMPORT_TOGGLE_COLLAPSE_CATEGORY:
    return {
      ...state,
      scrollToCategoryId: action.id,
      scrollToServiceId: null,
      list: state.list.map((category) => {
        if (category.provider_category_id === action.id) {
          return { ...category, collapsed: !category.collapsed };
        }
        return category;
      }),
      listDefault: state.listDefault.map((category) => {
        if (category.provider_category_id === action.id) {
          return { ...category, collapsed: !category.collapsed };
        }
        return category;
      }),
    };
  case types.IMPORT_TOGGLE_INFO_SERVICE:
    return {
      ...state,
      scrollToCategoryId: null,
      list: state.list.map((category, index) => {
        if (index === action.categoryIndex) {
          return {
            ...category,
            services: category.services.map((item) => {
              if (item.id === action.id) {
                return {
                  ...item,
                  showInfo: !item.showInfo,
                };
              }

              return item;
            }),
          };
        }
        return category;
      }),
    };
  case types.IMPORT_SORT_BY_RATE:
    const sortType = state.sortRate === 'all' ? 'desc' : state.sortRate === 'desc' ? 'asc' : 'all';
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
      sortRate: sortType,
      list: sortByRate(sortType, state),
    };
  case types.IMPORT_CHANGE_SEARCH:
    return {
      ...state,
      isLoading: true,
      search: action.value,
    };
  case types.IMPORT_CHANGE_SEARCH_SUCCESS:
    const allUncollapsedList = state?.listDefault?.map((item) => ({ ...item, collapsed: false }));
    return {
      ...state,
      scrollToCategoryId: 0,
      scrollToServiceId: null,
      isLoading: false,
      list: getListAfterFilter(
        state.search.trim() ? allUncollapsedList : state.listDefault,
        state.checked,
        state.search,
        state.search.trim() ? false : state.hideAdded,
        state.sortRate,
      ),
    };
  case types.IMPORT_SERVICE_SELECTED_ADD:
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
      checked: [...state.checked, action.id],
      list: getListAfterFilter(state.list, [...state.checked, action.id], state.search, state.hideAdded),
    };
  case types.IMPORT_SERVICE_SELECTED_DELETE:
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
      checked: state.checked.filter((item) => item !== action.id),
      list: getListAfterFilter(
        state.list,
        state.checked.filter((item) => item !== action.id),
        state.search,
        state.hideAdded,
      ),
    };
  case types.IMPORT_SERVICE_SELECTED_ALL_ADD:
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
      checked: [...new Set([...state.checked, ...action.list])],
      list: getListAfterFilter(state.list, [...state.checked, ...action.list], state.search, state.hideAdded),
    };
  case types.IMPORT_SERVICE_SELECTED_ALL_DELETE:
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
      checked: state.checked.filter((id) => !action.list.includes(id)),
      list: getListAfterFilter(
        state.list,
        state.checked.filter((id) => !action.list.includes(id)),
        state.search,
        state.hideAdded,
      ),
    };
  case types.IMPORT_STEP_2:
    return {
      ...state,
      listSelected: getSelectedList(state.listDefault, state.checked, action.provider),
      search: '',
      step: 2,
    };
  case types.IMPORT_TOGGLE_EDIT_SERVICE:
    return {
      ...state,
      listSelected: state.listSelected.map((category, index) => {
        if (index === action.categoryIndex) {
          return {
            ...category,
            services: category.services.map((item) => {
              if (item.id === action.id) {
                return {
                  ...item,
                  showEdit: !item.showEdit,
                };
              }

              return item;
            }),
          };
        }
        return category;
      }),
    };
  case types.IMPORT_CHANGE_SERVICE_FORM:
  case types.IMPORT_SAVE_SERVICE_CHANGES:
    return {
      ...state,
      listSelected: action.list,
    };
  case types.IMPORT_STEP_1:
    return {
      ...state,
      listSelected: null,
      step: 1,
      error: null,
      sortRate: 'all',
      options: {
        ...state.options,
        auto_rate_fixed: null,
        auto_rate_percent: null,
      },
    };
  case types.IMPORT_RESET_RAISE:
    return {
      ...state,
      error: null,
      listSelected: state.listSelected.map((category) => ({
        ...category,
        services: category.services.map((service) => ({
          ...service,
          locked: false,
          rate: service.rateCopy,
        })),
      })),
      options: {
        ...state.options,
        auto_rate_fixed: null,
        auto_rate_percent: null,
      },
    };
  case types.IMPORT_CHANGE_RATE_LOADING:
    return {
      ...state,
      isLoadingRate: action.value,
    };
  case types.IMPORT_CHANGE_RATE_FIXED:
    return {
      ...state,
      error: null,
      isLoadingRate: true,
      options: {
        ...state.options,
        auto_rate_fixed: action.value,
      },
    };
  case types.IMPORT_CHANGE_RATE_PERCENT:
    return {
      ...state,
      error: null,
      isLoadingRate: true,
      options: {
        ...state.options,
        auto_rate_percent: action.value,
      },
    };
  case types.IMPORT_CHANGE_DESCRIPTION:
    return {
      ...state,
      options: {
        ...state.options,
        support_copy_descriptions: action.value,
      },
    };
  case types.IMPORT_CHANGE_RATE_SYNC:
    return {
      ...state,
      listSelected: state.listSelected
        ? state.listSelected.map((category) => ({
          ...category,
          services: category.services.map((service) => {
            const findService = action.list.find((item) => item.provider_service_id === service.id);
            return {
              ...service,
              rate: findService && !service.locked ? findService.rate : service.rate,
            };
          }),
        }))
        : null,
    };
  case types.IMPORT_CHANGE_RATE_SYNC_SUCCESS:
    return {
      ...state,
      isLoadingRate: false,
    };
  case types.IMPORT_SERVICE_LOCKED:
    return {
      ...state,
      listSelected: state.listSelected.map((category) => ({
        ...category,
        services: category.services.map((service) => ({
          ...service,
          locked: service.id === action.id ? action.value : service.locked,
        })),
      })),
    };
  case types.IMPORT_CHANGE_RATE:
    return {
      ...state,
      error: null,
      listSelected: action.list,
    };
  case types.IMPORT_SUBMIT:
    return {
      ...state,
      error: null,
      isLoading: true,
    };
  case types.IMPORT_SUBMIT_SUCCESS:
    return {
      ...state,
      success: true,
    };
  case types.IMPORT_SUBMIT_ERROR:
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  case types.IMPORT_CHANGE_CATEGORY:
    return {
      ...state,
      list: state.list.map((category) => ({
        ...category,
        assign: category.provider_category_id === action.id ? action.value : category.assign,
      })),
      listDefault: state.listDefault.map((category) => ({
        ...category,
        assign: category.provider_category_id === action.id ? action.value : category.assign,
      })),
    };
  case types.IMPORT_TOGGLE_ADDED_VISIBLE:
    const lastChecked = state.checked?.length ? Number(state.checked[state.checked.length - 1]) : null;

    if (state.search.trim()) {
      return {
        ...state,
        hideAdded: !state.hideAdded,
      };
    }

    return {
      ...state,
      scrollToServiceId: lastChecked,
      hideAdded: !state.hideAdded,
      list: getListAfterFilter(
        state.hideAdded && !state.search.trim() ? state.listDefault : state.list,
        state.checked,
        state.search,
        !state.hideAdded,
      ),
    };
  default:
    throw new Error();
  }
};
